<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>

<div class="header-bar">
  <h1>Insurance Providers</h1>
</div>

<div class="">
  <div class="content-container">
    <div class="">
      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="name"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.insuranceProvider.value"
              />
              <label>Provider Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
          </div>
        </div>
      </form>

      <p-table
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        [(selection)]="selectedItem"
        *ngIf="isLoaded; else loading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="insuranceProvider">Insurance Provider</th>
            <th pSortableColumn="periodFrom">Period From</th>
            <th pSortableColumn="periodTo">Period To</th>
            <th pSortableColumn="callOutFee">Call Out Fee</th>
            <th pSortableColumn="mileageCap">Mileage Cap</th>
            <th pSortableColumn="mileageCost">Mileage Cost</th>
            <th pSortableColumn="mileagCost2">Mileage Cost 2</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.insuranceProvider }}</td>
            <td>
              <span title="{{ item.periodFrom | datex : 'ddd DD MMM' }}">
                {{ item.periodFrom | datex : 'ddd DD MMM' }}
              </span>
            </td>
            <td>
              <span title="{{ item.periodTo | datex : 'ddd DD MMM' }}">
                {{ item.periodTo | datex : 'ddd DD MMM' }}
              </span>
            </td>
            <td>{{ item.callOutFee }}</td>
            <td>{{ item.mileageCap }}</td>
            <td>{{ item.mileageCost }}</td>
            <td>{{ item.mileageCost2 }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED

            <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                         [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                         [(selection)]="selectedItem" *ngIf="isLoaded; else loading">
                <p-column field="insuranceProvider" header="InsuranceProvider" [sortable]="tru" [editable]="false"></p-column>
                <p-column field="periodFrom" header="Period From" [sortable]="tru" [editable]="false">
                    <ng-template let-item pTemplate="body">
                        <span title="{{item.periodFrom | datex:'ddd DD MMM'}}">
                            {{item.periodFrom | datex:'ddd DD MMM'}}
                        </span>
                    </ng-template>
                </p-column>
                <p-column field="periodTo" header="Period To" [sortable]="tru" [editable]="false">
                    <ng-template let-item="rowData" pTemplate="body">
                        <span title="{{item.periodTo | datex:'ddd DD MMM'}}">
                            {{item.periodTo | datex:'ddd DD MMM'}}
                        </span>
                    </ng-template>
                </p-column>
                <p-column field="callOutFee" header="Call Out Fee" [sortable]="tru" [editable]="false"></p-column>
                <p-column field="mileageCap" header="Mileage Cap" [sortable]="tru" [editable]="false"></p-column>
                <p-column field="mileageCost" header="Mileage Cost" [sortable]="tru" [editable]="false"></p-column>
                <p-column field="mileageCost2" header="Mileage Cost 2" [sortable]="tru" [editable]="false"></p-column>
            </p-dataTable>

            -->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right ui-button-danger"
          pButton
          (click)="onDelete(selectedItem)"
          label="Delete"
          icon="fa ui-icon-trash"
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit(selectedItem)"
          label="Edit"
          icon="fa ui-icon-mode-edit"
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Insurance Provider"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="providerForm" (ngSubmit)="save(providerForm.value)" autocomplete="off">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="insuranceProvider">Provider Name</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="insuranceProvider"
            formControlName="insuranceProvider"
            maxlength="50"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="insuranceProvider">Period From</label></div>
        <div class="ui-g-8">
          <p-calendar
            [(ngModel)]="periodFrom"
            [showTime]="false"
            name="periodFrom"
            dateFormat="D d MM"
            hourFormat="24"
            formControlName="periodFrom"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="insuranceProvider">Period To</label></div>
        <div class="ui-g-8">
          <p-calendar
            [(ngModel)]="periodTo"
            [showTime]="false"
            name="periodTo"
            dateFormat="D d MM"
            hourFormat="24"
            formControlName="periodTo"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="callOutFee">Call Out Fee</label></div>
        <div class="ui-g-8">
          <!--<input pInputText id="callOutFee" formControlName="callOutFee" type="number" />-->
          <input
            name="callOutFee"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            formControlName="callOutFee"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="mileageCap">Mileage Cap</label></div>
        <div class="ui-g-8">
          <!--<input pInputText id="mileageCap" formControlName="mileageCap" type="number" />-->
          <input
            name="mileageCap"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
            formControlName="mileageCap"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="mileageCost">Mileage Cost</label></div>
        <div class="ui-g-8">
          <!--<input pInputText id="mileageCost" formControlName="mileageCost" type="number" />-->
          <input
            name="mileageCost"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            formControlName="mileageCost"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="mileageCost2">Mileage Cost 2</label></div>
        <div class="ui-g-8">
          <!--<input pInputText id="mileageCost2" formControlName="mileageCost2" type="number" />-->
          <input
            name="mileageCost2"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            formControlName="mileageCost2"
          />
        </div>
      </div>
    </div>

    <div style="float: right">
      <button
        type="submit"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="providerForm && providerForm.invalid"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="close()"
      ></button>
    </div>
  </form>
</p-dialog>
